module.exports = __webpack_public_path__ + "img/report-lawyer.89f688e0.png";